import InfoCircle from '@carvana/icons/InfoCircle';
import { createComponent } from '@carvana/merch-components';
import classNames from 'classnames';
import styled from 'styled-components';

export const TimerText = styled('div').attrs(props => ({
  className: classNames(
    'font-bold',
    props.inverted ? 'text-white' : 'text-blue-6'
  )
}))`
  font-size: 24px;
  font-variant-numeric: tabular-nums;
  line-height: 24px;
`;

export const TimerTextHeading = styled(TimerText).attrs({
  className: 'mb-8'
})`
  font-size: 36px;
  line-height: 48px;
`;

export const OnHold = styled('div').attrs(props => ({
  className: classNames(
    'font-bold uppercase',
    props.inverted ? 'text-white' : 'text-grey-5'
  )
}))`
  font-size: 10px;
  line-height: 14px;
`;

export const InfoIcon = createComponent(InfoCircle, {
  className: 'pointer-events-auto ml-8 mt-8'
});
